import * as ReactSlider from "@radix-ui/react-slider";
import React from "react";
import styles from "./Slider.module.scss";

interface Props {
  name: string;
  value?: number;
  onChange?: (value: number[]) => void;
  step?: number;
  min?: number;
  max?: number;
  minRangeDisplay?: number;
}

const Slider: React.FC<Props> = (props) => {
  const rangeWidth =
    props.minRangeDisplay &&
    props.value !== undefined &&
    props.value < props.minRangeDisplay
      ? (props.minRangeDisplay / (props.max ?? 100)) * 100 + "%"
      : undefined;
  return (
    <ReactSlider.Root
      onValueChange={props.onChange}
      className={styles.container}
      defaultValue={[props.value ?? 50]}
      value={props.value === undefined ? undefined : [props.value]}
      min={props.min}
      max={props.max}
      step={props.step}
    >
      <ReactSlider.Track className={styles.track}>
        <ReactSlider.Range
          className={styles.range}
          style={{ width: rangeWidth }}
        />
      </ReactSlider.Track>
      <ReactSlider.Thumb className={styles.thumb} aria-label={props.name} />
    </ReactSlider.Root>
  );
};

export default Slider;
